import { render, staticRenderFns } from "./CustomFieldValuesModal.vue?vue&type=template&id=a5821196&"
import script from "./CustomFieldValuesModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldValuesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports